const getRpcUrl = () => {
    return "https://bsc-dataseed.binance.org/";
};

export default getRpcUrl;
